<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $t('message.fileManager') }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <file-manager v-bind:settings="settings"></file-manager>
            </div>
        </div>
    </div>
</template>

<script>
    import AppConfig from '../../constants/AppConfig'

    export default {
        name: "FileManager.vue",

        data() {
            return {
                settings: {
                    // axios headers
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                        Authorization: `Bearer ${window.localStorage.getItem('ms-token')}`,
                    },
                    baseUrl: AppConfig.baseUrl,   // overwrite base url Axios
                    windowsConfig: 2,                           // overwrite config
                    lang: 'fr',                                 // set language
                    translation: {                              // add new translation
                        name: 'fr',
                        content: {
                            about: 'Über',
                            back: 'Zurück',
                            //... see lang file structure
                        },
                    },
                }
            }
        }
    }
</script>

<style scoped>

</style>